exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".consent-pd[data-v-052d06bc]{max-width:900px;font-family:Arial,sans-serif;line-height:1.6;font-size:14px}.consent-container[data-v-052d06bc]{position:relative}.consent-textarea[data-v-052d06bc]{font-family:monospace;font-size:12px;line-height:1.4;resize:vertical;min-height:150px}.mt-2[data-v-052d06bc]{margin-top:.5rem}.text-muted[data-v-052d06bc]{color:#6c757d}.text-success[data-v-052d06bc]{color:#28a745}.mr-1[data-v-052d06bc]{margin-right:.25rem}", ""]);

// exports
